<template>
  <div class="app-container" ref="body">
    <div class="app-body">
      <!-- <div class="home-header">
        <img :src="imgLocal('header.png')" style="width:100%;">
      </div> -->
      <van-pull-refresh
        v-model="isLoading"
        success-text="刷新成功"
        @refresh="onRefresh"
        style="padding-bottom:5rem;"
      >
        <div class="home-user">
          <div class="headpic">
            <div>
              <van-image
                round
                width="4rem"
                height="4rem"
                :src="member.headpic"
              />
              <div class="text-center">{{ member.nickname || '请登录' }}</div>
            </div>
          </div>
          <div class="order-count">
            <div class="text-center">我的报名</div>
            <div class="count text-center">{{ countOrder }}</div>
          </div>
        </div>
        <div class="home-items">
          <h4>我的报名</h4>
          <template v-for="item in list">
            <div :key="item.id" class="item">
              <div v-if="item.pic" class="imgs" :style="imageStyle2">
                <img :src="imgPath(item.pic)">
              </div>
              <div class="detail">
                <div class="tit">
                  <div>{{ item.title }}</div>
                  <div class="tag">
                    <van-tag v-if="!item.status" color="#aaa" text-color="#fff">待付款</van-tag>
                    <van-tag v-if="item.status == 1" plain type="primary">已支付</van-tag>
                    <van-tag v-if="item.status == 2" plain type="success">已报名</van-tag>
                  </div>
                </div>
                <div class="con">
                  <div>{{ item.bmzy }} / {{ item.coursename }}</div>
                  <span class="price" v-html="webPrice(item.amount)"></span>
                </div>
                <div class="btns">
                  <van-button v-if="!item.status" type="danger" plain size="mini" style="margin-right:1rem;" @click="doDel(item)">删除报名</van-button>
                  <van-button v-if="!item.status" type="primary" size="mini" @click="doPay(item)">立即支付</van-button>
                  <van-button type="info" size="mini" plain style="margin-left:.5rem;" @click="$router.push('/order/'+ item.id)">查看详情</van-button>
                </div>
              </div>
            </div>
          </template>
          <van-empty v-if="!list || !list.length" image="error" description="还没有报名信息" />
        </div>
      </van-pull-refresh>
    </div>
    <AppFooter />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import siteMixin from '@/utils/site-mixin';
import AppFooter from '../app-footer.vue';
export default {
  components: {
    AppFooter
  },
  mixins: [siteMixin],
  data() {
    return {
      error: false,
      isLoading: false,
      list: [],
      countOrder: 0
    }
  },
  computed: {
    ...mapGetters([]),
    imageStyle() {
      let style = {};
      if (this.w) {
        style = {height: (this.w * 0.8) + 'px'};
      }
      return style;
    },
    imageStyle2() {
      let style = {}
      if (this.w) {
        let h = this.w * 0.618 * 0.26;
        style = {height: h + 'px'};
      }
      return style;
    },
    headerBg() {
      return {'background-image':'url('+ this.assetsPath +'static/images/header-bg.png)'};
    },
  },
  activated() {
    this.loadData();
  },
  methods: {
    loadData(callback) {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      this.doPost({
        url: 'site/home/member',
        data: {},
        okcb: (json) => {
          if (callback && callback instanceof Function) {
            callback(json);
          } else {
            this.list = json.list;
            this.countOrder = json.countOrder;
          }
        },
        cb: () => {
          this.$nextTick(() => this.isLoading = false);
        },
        errcb: () => {
          this.error = true;
        }
      });
    },
    onRefresh() {
      this.isLoading = false;
      this.loadData((json) => {
        this.list = json.list;
        this.countOrder = json.countOrder;

        this.$toast('刷新成功');
      });
    },
    doPay(item) {
      // 如果未登录，或缺失openid【微信浏览器中】，则登录
      if (!this.member.id || !this.member.openid) {
        this.login();
        return;
      }
      this.Toast.loading({
        message: '加载中...',
        forbidClick: true
      });
      this.doPost({
        url: 'site/signup/wxpay2/'+ item.id,
        data: {openid: this.member.openid},
        okcb: (json) => {
          // 如果需要登录获取openid
          if (json.needopenid) {
            this.login();
            return;
          }
          if (json.ok) {
            setTimeout(() => {
              this.Toast('已完成支付！');
            }, 20);
            item.status = json.status;
            return;
          }
          let params = {goods: { name: item.title, amount: item.amount }, orderid:json.orderid };
          if (json.code_url) {
            params.codeUrl = json.code_url;
          } else {
            params.wxpayparams = JSON.parse(json.payparams);
          }
          // 支付界面
          this.payforward = true;
          this.$router.push({ name:'signup-pay', params: params });
        },
        cb: () => {
          this.Toast.clear();
        },
        errcb: (json) => {
          if (json && json.message) {
            setTimeout(() => {
              this.Toast.fail(json.message);
            }, 10);
          }
        }
      });
    },
    doDel(item) {
      this.Dialog.confirm({
        message: '确定要删除该报名吗？'
      }).then(() => {
        this.Toast.loading({
          message: '加载中...',
          forbidClick: true
        });
        this.doPost({
          url: 'site/home/delorder/'+ item.id,
          okcb: () => {
            this.list.splice(this.list.indexOf(item), 1);
            setTimeout(() => {
              this.Toast.success('删除成功！');
            }, 300);
          },
          cb: () => {
            this.Toast.clear();
          }
        });
      }).catch(() => {
        // on cancel
      });
    }
  }
}
</script>
<style lang="less" scoped>
.app-body {
  padding-bottom:5.2rem;
}
.home-user {
  .flex-center-v();
  margin:1rem;
  padding:1rem;
  background-color:#fff;
  border-radius:1rem;
  .shadow_black(0 0 10px 0, .05);
  .headpic {
    margin-right:2rem;
  }
  .order-count {
    padding-left: 2rem;
    border-left: 1px #eee solid;
  }
  .count {
    color:green;
    .fontsize(2rem);
  }
}
.home-items {
  padding:0 1rem 2rem;
  h4 {
    margin-bottom:.25rem;
    color:#888;
  }
  .item {
    .flex();
    margin-bottom:1rem;
    background-color:#fff;
    border-radius:1rem;
    .shadow_black(0 0 10px 0, .05);
    .imgs {
      padding:.5rem;
      margin-right:1rem;
      width: 26%;
      flex-shrink: 0;
      img {
        width:100%;
        height:100%;
        object-fit: cover;
      }
    }
    .detail {
      flex-grow: 1;
      padding:.5rem;
      .tit {
        .flex-center-v();
        justify-content: space-between;
        .fontsize(1.2rem);
        .tag {
          margin-left: auto;
          padding-left: .5rem; 
        }
      }
      .con {
        .flex-center-v();
        justify-content: space-between;
        margin-top:.25rem;
        color:#888;
        .price {
          display: inline-block;
          margin-left:auto;
          color: #ff6600;
          .fontsize(1.4rem);
          small {
            .fontsize(.85rem);
          }
        }
      }
      .btns {
        text-align: right;
        margin-top:.5rem;
      }
    }
  }
}
</style>